document.addEventListener("turbo:load", function() {
  searchContractNotes();
  initializeBrokerAutoFill();
  formatContractNumber();
});

function searchContractNotes() {
  const input = document.getElementById("contract-search-input");
  const form = document.getElementById("contract-search-form");
  const hiddenInput = document.getElementById("selected-contract-ids");
  const colourInput = document.getElementById("color-filter-select");
  const dateInput = document.getElementById("contract_date");

  if (!input || !form) return;

  if (input.value.trim() !== "") {
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }

  let debounceTimer;

  input.addEventListener("input", function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      form.dataset.searchOnly = "true";
      form.requestSubmit();
    }, 1300);
  });

  if (dateInput && form) {
    dateInput.addEventListener("change", function() {
      form.requestSubmit();
    });
  }

  if (colourInput) {
    colourInput.addEventListener("change", function () {
      form.requestSubmit();
    });
  }

  if (hiddenInput) {
    form.addEventListener("submit", function (e) {
      if (form.dataset.searchOnly === "true") {
        delete form.dataset.searchOnly;
        return;
      }

      const selected = Array.from(document.querySelectorAll(".contract-checkbox:checked")).map(cb => cb.value);
      if (selected.length === 0) {
        e.preventDefault();
        alert("Please select at least one contract to update status.");
        return;
      }
      hiddenInput.value = selected.join(",");
    });
  }
}

function initializeBrokerAutoFill() {
  const sellerBrokerSelect = document.getElementById("seller_broker_id");
  const financerBrokerSelect = document.getElementById("financer_broker_id");
  const buyerBrokerSelect = document.getElementById("buyer_broker_id");

  if (!sellerBrokerSelect) return;

  sellerBrokerSelect.addEventListener("change", () => {
    const selectedValue = sellerBrokerSelect.value;

    if (financerBrokerSelect && (financerBrokerSelect.value === "" || financerBrokerSelect.dataset.autofilled === "true")) {
      financerBrokerSelect.value = selectedValue;
      financerBrokerSelect.dataset.autofilled = "true";
    }

    if (buyerBrokerSelect && (buyerBrokerSelect.value === "" || buyerBrokerSelect.dataset.autofilled === "true")) {
      buyerBrokerSelect.value = selectedValue;
      buyerBrokerSelect.dataset.autofilled = "true";
    }
  });

  if (financerBrokerSelect) {
    financerBrokerSelect.addEventListener("change", () => {
      financerBrokerSelect.dataset.autofilled = "false";
    });
  }

  if (buyerBrokerSelect) {
    buyerBrokerSelect.addEventListener("change", () => {
      buyerBrokerSelect.dataset.autofilled = "false";
    });
  }
}
function formatContractNumber() {
  const input = document.querySelector('input[name="contract_note[contract_no]"]');
  if (!input) return;

  input.addEventListener("blur", () => {
    let val = input.value.toUpperCase();
    const parts = val.split('/');

    if (/^\d{1,5}$/.test(parts[0])) {
      parts[0] = parts[0].padStart(5, '0');
    }

    input.value = parts.join('/');
  });
}

